import markerListFormatterItemRenderer from './marker_list_formatter_item_renderer';
import styles from 'src/js/common/components/formatters/MarkerListFormatter.less';
import baseListFormatterParams from 'src/js/lib/raw_rendering/base_list_formatter_params';

/**
 * Returns raw Html version of MarkerListFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function markerListFormatter(params, services = {}) {
  const {ownValue} = baseListFormatterParams(params);
  return ownValue
    ? `<div class="${styles.dlMarkerListWrapper}">
            ${
              ownValue &&
              ownValue.data &&
              ownValue.data
                .map((item) =>
                  markerListFormatterItemRenderer({item}, services)
                )
                .join('')
            }
        </div>`
    : '';
}
